import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
export default {
  getOneInProject(projectUid, photoUid) {
    return raw.get(routes.photos.oneInProject(projectUid, photoUid));
  },
  updateOneInProject(projectUid, photoUid, body = undefined) {
    return raw.patch(routes.photos.oneInProject(projectUid, photoUid), body);
  },
  deleteOneInProject(projectUid, photoUid) {
    return raw.delete(routes.photos.oneInProject(projectUid, photoUid));
  },
};
